import { render, staticRenderFns } from "./PowerSummarizerMain.vue?vue&type=template&id=670641ad&scoped=true"
import script from "./PowerSummarizerMain.vue?vue&type=script&lang=js"
export * from "./PowerSummarizerMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670641ad",
  null
  
)

export default component.exports